// Social auth on/off is controlled at runtime by the antispam flag
// "social_auth_enabled" (seeded into the store server-side, read via
// getSocialAuthEnabled) — there is no build-time constant for it any more.

/**
 * mojeID login feature flag — set to true once MOJEID_CLIENT_ID + MOJEID_CLIENT_SECRET
 * env vars are configured on the server and the app is registered with CZ.NIC.
 */
export const MOJEID_ENABLED = false;
